import React from "react";
import healthLogo from "assets/icons/healthLogo.svg";
import lyfLogo from "assets/icons/lyfLogo.svg";
import generalLogo from "assets/icons/generalLogo.svg";
import MotorLogo from "assets/icons/moterLogo.svg";
import defaultPolicyImg from "assets/icons/defaultPolicyImg.svg";

interface PolicyIconProps {
  type: "Health Insurance" | "Life Insurance" | "General Insurance" | "Motor Insurance";
  className?: string;
}

export const PolicyIcon: React.FC<PolicyIconProps> = ({ type, className = "" }) => {
  const getIconByType = () => {
    switch (type) {
      case "Health Insurance":
        return <img src={healthLogo} className="w-13 h-13" />;
      case "Life Insurance":
        return <img src={lyfLogo} className="w-13 h-13" />;
      case "General Insurance":
        return <img src={generalLogo} className="w-13 h-13" />;
      case "Motor Insurance":
        return <img src={MotorLogo} className="m-2" />;
      default:
        return <img src={defaultPolicyImg} className="w-13 h-13" />;
    }
  };

  const getBackgroundColorByType = () => {
    switch (type) {
      case "Health Insurance":
        return "border-[#CEE2D4] bg-[#F1F8F5]";
      case "Life Insurance":
        return "border-[#E9D6D4] bg-[#FCEEED]";
      case "General Insurance":
        return "border-[#C1DDED] bg-[#ECF2F6]";
      case "Motor Insurance":
        return "bg-white rounded-[0.205rem]";
      default:
        return "";
    }
  };

  return <div className={`${getBackgroundColorByType()} ${className}`}>{getIconByType()}</div>;
};
